// extracted by mini-css-extract-plugin
export default {"recordListWrapper":"RecordList_recordListWrapper__MjPsL"};